import React, { useEffect, useState } from 'react'
import airbnb from '../../../assets/integrations/airbnb-big.svg'
import check from '../../../assets/integrations/check.svg'
import styled, { ITheme } from '../../../theme'
import { useTranslation } from 'react-i18next'
import { FiExternalLink } from 'react-icons/fi'
import { CountryCode } from '../../../i18n/countryCodes'
import { useSelector } from 'react-redux'
import { getUserLanguage } from '../../../reducers/userAccount/selectors/userAccount'
import {
  getAirbnbChecked,
  getAirbnbStatus,
} from '../../../reducers/airbnb/selectors'
import { IntegrationStatus } from '../../../reducers/airbnb'
import { is } from '../../../components/MediaQuery'
import { useScript } from '../../../hooks/useScript'
import { withRouter } from 'react-router'

const Wrapper = styled.div<any>`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: ${props =>
    Number(props.mobile) ? 'calc(100vh - 132px)' : 'calc(100vh - 255px)'};
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding: 0px 20px;
  }
`

const Header = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: justify;
  margin-bottom: 30px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #696a6d;
    margin-bottom: 20px;
    text-decoration: none solid rgb(105, 106, 109);
    text-align: justify;
  }
`

const Label = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: left;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #696a6d;
    text-decoration: none solid rgb(105, 106, 109);
    text-align: justify;
  }
`

const ALink = styled.a`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #17a3dd;
  text-decoration: none solid rgb(23, 163, 221);
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 20px;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    background-size: cover;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #17a3dd;
    width: 100%;
    text-decoration: none solid rgb(23, 163, 221);
  }
`

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: calc(100% - 20px);
  padding-top: 12px;
  height: 60px;
  background-color: white;
  display: flex;
  justify-content: center;
`

const Benefit = ({ children }) => (
  <div style={{ display: 'flex', alignItems: 'center', margin: '4px 0px' }}>
    <img src={check} alt="check" />
    <Label style={{ padding: '0px 0px 0px 12px' }}>{children}</Label>
  </div>
)

const Link = ({ children }) => {
  const lang = useSelector(getUserLanguage)

  const mapLanguage = (lang: CountryCode) => {
    switch (lang) {
      case 'pl':
        return 'https://support.bed-booking.com/hc/pl/sections/4404464577298'
      case 'pl_PL':
        return 'https://support.bed-booking.com/hc/pl/sections/4404464577298'
      case 'it':
        return 'https://support.bed-booking.com/hc/it/sections/4404464577298'
      case 'es':
        return 'https://support.bed-booking.com/hc/es-es/sections/4404464577298'
      default:
        return 'https://support.bed-booking.com/hc/en-us/sections/4404464577298'
    }
  }

  return (
    <ALink href={mapLanguage(lang as any)} target={'_blank'}>
      {children}
      <FiExternalLink style={{ fontSize: '14px', marginLeft: '5px' }} />
    </ALink>
  )
}

function LoginAirbnb({ location, mobile }: any) {
  const { t } = useTranslation()
  const status = useSelector(getAirbnbStatus)
  const checked = useSelector(getAirbnbChecked)
  const [refresh, setRefresh] = useState(false)
  const isDesktop = is.desktop()

  useEffect(() => {
    setTimeout(() => {
      setRefresh(!refresh)
    }, [200])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Wrapper mobile={mobile} key={location.key + refresh}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: isDesktop ? '0' : '75px',
        }}
      >
        <img
          src={airbnb}
          alt={'airbnb-logo-big'}
          style={{
            alignSelf: 'center',
            width: '319px',
            height: '101px',
            marginBottom: '31px',
            marginTop: '30px',
          }}
        />
        <Header>{t('OUT_22_sneak_peak_1')}</Header>
        <Benefit>{t('OUT_22_sneak_peak_2')}</Benefit>
        <Benefit>{t('OUT_22_sneak_peak_3')}</Benefit>
        <Benefit>{t('OUT_22_sneak_peak_4')}</Benefit>
        <Label style={{ marginTop: '27px' }}>{t('OUT_22_sneak_peak_5')}</Label>
        <Link>{t('BBO_3669_more')}</Link>
      </div>

      {!isDesktop && checked && status === IntegrationStatus.NotIntegrated && (
        <ButtonWrapper>
          <AirbnbButton />
        </ButtonWrapper>
      )}
    </Wrapper>
  )
}

export const AirbnbButton = withRouter<any, any>(({ location, disabled }) => {
  const isDesktop = is.desktop()
  const [refresh, setRefresh] = useState(false)
  const checked = useSelector(getAirbnbChecked)

  useScript('https://www.airbnb.com/platform_js', checked, isDesktop, refresh)

  useEffect(() => {
    setTimeout(() => {
      setRefresh(!refresh)
    }, [200])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key])

  useEffect(() => {
    const interval = setInterval(() => {
      const element = document.getElementById('airbnb-button')
      if (element && element.children.length) {
        if (disabled) {
          ;(element as any).children[1].style.filter = 'saturate(0.0)'
        } else {
          ;(element as any).children[1].style.filter = 'unset'
        }
      }
    }, 100)

    return () => {
      clearInterval(interval)
    }
  }, [disabled])

  return (
    <span
      className="airbnb-connect"
      data-client-id={process.env.REACT_APP_AIRBNB_CLIENT_ID}
      data-scope="property_management"
      data-width={'260px'}
      data-redirect-uri={process.env.REACT_APP_AIRBNB_REDIRECT_URL}
    />
  )
})

export interface ILoginAirbnb {}

export default withRouter(LoginAirbnb)
